import { MEMBERGROUPS_SUCCESS, MEMBERGROUPS_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const memberGroupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case MEMBERGROUPS_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case MEMBERGROUPS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default memberGroupsReducer;
